import Repository from '../axios'

export default {
  fetchAllGeneratedReports(subject_name = '') {
    return Repository.get(`/admin/generated-reports?subject_name=${subject_name}`)
  },
  generateReport(id, assessment_type, payload) {
    return Repository.post(`/admin/generate-report/${assessment_type}/${id}`, payload)
  }
};
